/** @format */
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { FilledExtensionApplication, PlanData } from '../types';

@Component({
    selector: 'app-study-right-extension-application-preview',
    templateUrl: './study-right-extension-application-preview.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class StudyRightExtensionApplicationPreviewComponent {
    @Input({ required: true }) planData: PlanData;
    @Input({ required: true }) filledExtensionApplication: FilledExtensionApplication;

    @Output() readonly continue = new EventEmitter<void>();
    @Output() readonly previous = new EventEmitter<void>();
}
